export var HEADER_NAVIGATION_MENU_CLASS_PREFIX = 'HeaderNavigationMenu';
export var headerNavigationMenuRoot = 'HeaderNavigationMenuRoot';